<template>
  <div>
    <nav class="navbar navbar-expand-md navbar-dark bg-dark fixed-top">
      <a class="navbar-brand" href="#">Sangeeta Jha</a>
      <button
        class="navbar-toggler"
        type="button"
        data-toggle="collapse"
        data-target="#navbarSupportedContent"
        aria-controls="navbarSupportedContent"
        aria-expanded="false"
        aria-label="Toggle navigation"
      >
        <span class="navbar-toggler-icon"></span>
      </button>

      <div class="collapse navbar-collapse" id="navbarSupportedContent">
          <ul class="navbar-nav mr-auto">
          <li class="nav-item active"><router-link class="nav-item nav-link" to="/"><span class="sr-only">(current)</span>Home
          </router-link></li>
          <li class="nav-item"><router-link class="nav-item nav-link" to="/about">About</router-link></li>
          <li class="nav-item"><router-link class="nav-item nav-link" to="/projects">Projects</router-link></li>
          <li class="nav-item"><router-link class="nav-item nav-link" to="/workexperience">Work Experience</router-link></li>
        </ul>
      <!--<form class="form-inline">
        <router-link to="/contact" class="btn nav-btn my-2 my-sm-0">
          Say Hello
        </router-link>
      </form>-->
        
      </div>
    </nav>
  </div>
</template>

<script>
export default {
  name: "navbar"
};
</script>

<style>
.nav-btn {
  border-color: blueviolet;
  border-radius: 20%;
  color: white;
  text-decoration: none;
  height: 2.5em;
  float: right;
}
.nav-btn:hover {
  background: blueviolet;
  color: white;
}
</style>